import { ClientEvents } from 'common/events/ClientEvents';
import { QueryParams } from 'common/urls/QueryParams';
import React, { useEffect } from 'react';
import { ReactComponent as CurlyArrowDown } from 'src/assets/svg/meal-plan/curlyArrowDown.svg';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { useTracker } from 'src/shared/hooks/useTracker';
import { StringParam, useQueryParam } from 'use-query-params';
import Button, { ButtonType } from 'web-common/src/shared/design-system/components/Button';
import { Container, ContainerWidth } from 'web-common/src/shared/design-system/components/Container';
import { Icon, IconColor, IconName } from 'web-common/src/shared/design-system/components/Icon';
import { ExploreTabNames } from '../consts';

const VALUE_PROPS: { copy: string; iconName: IconName }[] = [
  {
    copy: 'Free delivery',
    iconName: 'main',
  },
  {
    copy: 'Curated for your household',
    iconName: 'homemade',
  },
  {
    copy: 'Access to top-rated shefs',
    iconName: 'starEmpty',
  },
  {
    copy: 'Preferred pricing',
    iconName: 'promo',
  },
];

export const WeeklyShefServiceBanner: React.FC = () => {
  const [currentUser] = useCurrentUser();
  const tracker = useTracker();
  const [, setTab] = useQueryParam(QueryParams.TAB, StringParam);

  useEffect(() => {
    tracker.track(ClientEvents.EXPLORE_MEAL_PLAN_HERO_BANNER_SHOWN, {
      userId: currentUser?.id,
      currentUserLastSearchedZipCode: currentUser?.lastSearchedZipCode,
    });
  }, []);

  const onClick = () => {
    setTab(ExploreTabNames.ShefService, 'replaceIn');
  };

  return (
    <div className='cursor-pointer bg-rice py-6' onClick={onClick}>
      <Container containerWidth={ContainerWidth.Narrow} className='relative'>
        <div className='flex flex-col items-center gap-4'>
          <h3 className='text-h3 uppercase text-eggplant'>
            Weekly <span className='font-quick-writers text-raspberry'>Shef</span> Service
          </h3>
          <div className='flex flex-wrap justify-center gap-2 md:px-14'>
            {VALUE_PROPS.map(({ copy, iconName }) => (
              <p className='m-0 flex items-center gap-1 text-label-700 uppercase text-eggplant' key={copy}>
                <Icon name={iconName} color={IconColor.RASPBERRY} />
                {copy}
              </p>
            ))}
          </div>
          <div className='relative flex w-full justify-center'>
            <Button buttonType={ButtonType.TextLink}>Get started</Button>
            <CurlyArrowDown className='absolute -top-4 left-[calc(50%-100px)] z-banner h-20 w-14 rotate-[55deg] text-mint-400' />
          </div>
        </div>
      </Container>
    </div>
  );
};
